// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__2hkS5","formControl":"addForm_formControl__g7GY8","list":"addForm_list__h32TD","btnWrpper":"addForm_btnWrpper__0x-mo"};